class CouponRequest {
    CouponRequestURL(total_price, cupon_name) {
        return process.env.REACT_APP_BASEURL + "CuponCheck/" + total_price + "/" + cupon_name
    }

    InvoiceNoRequestURL() {
        return process.env.REACT_APP_BASEURL + "GetInvoiceNo";
    }

}

export const { CouponRequestURL, InvoiceNoRequestURL } = new CouponRequest();